import React, { useEffect, useState } from "react";
import SettingContainer from "../SettingContainer";
import ActivityLoader from "../../Common/ActivityLoader";
import Notification from "../../Common/Notification";
import { useTheme } from "../../../DataStore/ThemeContext";
import ajaxConfig from "../../../util/remote/ajaxConfig";

const GatewayConfig = () => {
  const { setNotify, openSettings } = useTheme();
  const [gateway, setGateway] = useState(null);

  useEffect(() => {
    getGateway();
  }, []);

  const handleRefresh = () => {
    getGateway();
  };

  const getGateway = async () => {
    let server_response = await ajaxConfig.fetchGateways();
    if (server_response.status === "OK") {
      setGateway(server_response.details);
    } else {
      setNotify(
        <Notification
          message={server_response.message}
          type="danger"
          closable={false}
        />
      );
    }
  };

  const truncateText = (text, maxLength) => {
    if(!text) return '';
    if (text.length > maxLength) {
      return (
        <span title={text}>
          {text.substring(0, maxLength)}...
        </span>
      );
    }
    return text;
  };

  const menu = () => (
    <>
      <button
        type="button"
        tabIndex="0"
        className="dropdown-item"
        onClick={handleRefresh}
      >
        <i className="dropdown-icon fa fa-refresh"> </i>
        <span>Refresh</span>
      </button>
    </>
  );

  const handleConfigure = (record) => {
    record.onComplete = handleRefresh;
    openSettings("Configure Gateway", "ConfigGateway", record, "Save Configuration");
  }

  return (
    <SettingContainer
      title="Payment Gateways"
      icon="fab fa-amazon-pay"
      Menu={menu}
    >
      
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Collector Name</th>
                    <th>Collector Code</th>
                    <th>Username</th>
                    <th>Password</th>
                    <th>API Key</th>
                    <th>Cash Account</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(gateway) && gateway.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.collector_name}</td>
                      <td>{item.collector_code}</td>
                      <td>{item.username}</td>
                      <td>{"********"}</td>
                      <td>{truncateText(item.api_key, 10)}</td>
                      <td>{item.cash_account?.account_name  || "Not Set"}</td>
                      <td>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => handleConfigure(item)}>
                          Configure
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
      
        {!gateway && <ActivityLoader />}
        </SettingContainer>
  );
};

export default GatewayConfig;
